import featureImage1 from "./images/feature_1.svg";
import featureImage2 from "./images/feature_2.svg";
import featureImage3 from "./images/feature_3.svg";
import featureImage4 from "./images/feature_4.svg";
import featureImage5 from "./images/feature_5.png";

export const featureData = [
    {
        image: featureImage1,
        title: "Authenticity Check",
        subTitle: "Authenticity and quality check for all products"
    },
    {
        image: featureImage2,
        title: "Return Policy",
        subTitle: "Return & refund policy available"
    },
    {
        image: featureImage3,
        title: "100% Secure Payment",
        subTitle: "Guarantee highly secure payments"
    },
    {
        image: featureImage4,
        title: "Dedicated Support",
        subTitle: "Monday - Saturday (10-20Hrs)"
    },
    {
        image: featureImage5,
        title: "Weekly Offers",
        subTitle: "Register for discounts & offers"
    },
]